export const regions = {
  EU: 'Default (EU)',
  US: 'US',
} as const;

export const issRegionMap = [
  { iss: 'https://auth.us.wlloyalty.net/', region: 'US' },
  { iss: 'https://auth.wlloyalty.net/', region: 'EU' },
];

export type ConsoleRegion = keyof typeof regions;

const config = {
  development: {
    rewards: 'http://localhost:8080/v1',
    marketing: 'http://localhost:8081/v1',
    receipts: 'http://localhost:8082/v1',
    core: 'http://localhost:8083/v1',
    bridge: 'http://localhost:8085/v1',
    analyticsHost: null,
    micrositeDomain: null,
    metabaseHost: null,
  },
  staging: {
    EU: {
      rewards: 'https://api.staging.rewards.wlloyalty.net/v1',
      marketing: 'https://api.staging.marketing.wlloyalty.net/v1',
      receipts: 'https://api.staging.receipts.wlloyalty.net/v1',
      core: 'https://api.staging.core.wlloyalty.net/v1',
      bridge: 'https://api.staging.bridge.wlloyalty.net/v1',
      intelligence: 'https://api.staging.intelligence.wlloyalty.net/v1',
      analyticsHost: null,
      micrositeDomain: 'staging.web.wlloyalty.net',
      metabaseHost: null,
    },
    US: {
      rewards: 'https://api.staging.rewards.us.wlloyalty.net/v1',
      marketing: 'https://api.staging.marketing.us.wlloyalty.net/v1',
      receipts: 'https://api.staging.receipts.us.wlloyalty.net/v1',
      core: 'https://api.staging.core.us.wlloyalty.net/v1',
      bridge: 'https://api.staging.bridge.us.wlloyalty.net/v1',
      intelligence: 'https://api.staging.intelligence.us.wlloyalty.net/v1',
      analyticsHost: null,
      micrositeDomain: 'staging.web.us.wlloyalty.net',
      metabaseHost: null,
    },
  },
  production: {
    EU: {
      rewards: 'https://api.rewards.wlloyalty.net/v1',
      marketing: 'https://api.marketing.wlloyalty.net/v1',
      receipts: 'https://api.receipts.wlloyalty.net/v1',
      core: 'https://api.core.wlloyalty.net/v1',
      bridge: 'https://api.bridge.wlloyalty.net/v1',
      intelligence: 'https://api.intelligence.wlloyalty.net/v1',
      analyticsHost: 'https://reports.wlloyalty.net',
      micrositeDomain: 'web.wlloyalty.net',
      metabaseHost: 'https://analytics.wlloyalty.net',
    },
    US: {
      rewards: 'https://api.rewards.us.wlloyalty.net/v1',
      marketing: 'https://api.marketing.us.wlloyalty.net/v1',
      receipts: 'https://api.receipts.us.wlloyalty.net/v1',
      core: 'https://api.core.us.wlloyalty.net/v1',
      bridge: 'https://api.bridge.us.wlloyalty.net/v1',
      intelligence: 'https://api.intelligence.us.wlloyalty.net/v1',
      analyticsHost: 'https://reports.us.wlloyalty.net',
      micrositeDomain: 'web.us.wlloyalty.net',
      metabaseHost: 'https://analytics.us.wlloyalty.net',
    },
  },
};

const {
  isProduction = false,
}: {
  isProduction: boolean | undefined;
} = JSON.parse(localStorage.getItem('wll')!) || {};

const useLiveData =
  process.env.NODE_ENV === 'production' ||
  process.env.VITE_REACT_APP_USE_LIVE_DATA === '1';

export const production = config.production;
export const staging = config.staging;

export default useLiveData
  ? isProduction
    ? config.production
    : config.staging
  : config.development;

export const hotJarConfig = {
  development: {
    id: '2666481',
  },
  staging: {
    id: '6405674',
  },
  production: {
    id: '6405679',
  },
};
